export default {
  namespace: 'toast',
  state: {
    message: null,
  },
  effects: {
  },
  reducers: {
    show(state, action) {
      return {
        ...state,
        message: action.payload
      };
    },
    dismiss(state, action) {
      return {
        ...state,
        message: null
      };
    }
  }
};

/*
  #TODO: This is not what's all available, just a design sketch.
  -- TJC - August 14, 2020
*/
// const messageObj = {
//   text: "",
//   icon: </>,
//   color: "",
//   iconColor: "",
//   timeout: 5000,
//   dismissable: bool,
//   loader: bool
// }